(() => {
  const styledSelector = [
    '.mb-product-copy',
    '.mb-product-content',
    '.mbc-intro',
    '.mb-product-intro',
    '.mb-product-panel',
    '.mb-makers-frame',
  ].join(',');

  const restoreDescription = (description) => {
    if (description.querySelector(styledSelector)) return;

    const lead = description.querySelector(':scope > .mb-geo-lead');
    if (!lead) return;

    const sourceNodes = [...description.children].filter((node) => node !== lead);
    if (!sourceNodes.length) return;

    const copy = document.createElement('div');
    copy.className = 'mb-product-copy mb-product-copy--restored';
    lead.insertAdjacentElement('afterend', copy);

    let panel = null;

    sourceNodes.forEach((node) => {
      const text = (node.textContent || '').replace(/\u00a0/g, ' ').trim();
      const isSpacer = node.tagName === 'P' && !text && !node.querySelector('img, video, iframe');

      if (isSpacer) {
        node.remove();
        panel = null;
        return;
      }

      if (!panel) {
        panel = document.createElement('section');
        panel.className = 'mb-product-panel';
        copy.appendChild(panel);
      }

      panel.appendChild(node);
    });
  };

  const restoreDescriptions = (root = document) => {
    root.querySelectorAll('.mb-product-description').forEach(restoreDescription);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => restoreDescriptions(), { once: true });
  } else {
    restoreDescriptions();
  }

  document.addEventListener('shopify:section:load', (event) => restoreDescriptions(event.target));
})();
